import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GridsterModule} from 'angular2gridster';
import {HomeComponent} from './components/dashboard/home.component';
import {SharedModule} from '../../shared/shared.module';
import {FormsModule} from '@angular/forms';
import {CoreModule} from '../../core/core.module';
import {HomeRoutingModule} from './home-routing.module';
import {NgxMasonryModule} from "ngx-masonry";
import { DemoMaterialModule } from "../administrator/material-module";
import { VideoComponent } from "./components/video/video.component";
import { VideoService } from "../photo/services/video.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        SharedModule,
        GridsterModule.forRoot(),
        HomeRoutingModule,
        NgxMasonryModule,
        DemoMaterialModule
    ],
    providers : [VideoService],
    declarations: [HomeComponent, VideoComponent],
    exports: [HomeComponent]
})
export class HomepageModule {
}
